import {
    DeliveryMethod,
    ExternalApplicationRequest,
    LoanApplicationSubmitSource2,
    SubmittingUser,
} from '@servicetitan/financing-api-client';
import { ApplicationData } from '../application/ApplicationDataStore';
import { PartialDeep } from '@servicetitan/financing-utils-shared';

export interface PrepareExternalApplicationFromApplicantDataParams {
    applicationData: ApplicationData;
    setupData: {
        tenantId: string;
        provider: string;
        buId: string;
        jobId?: string | null;
        customerId?: string | null;
        technicianId?: string | null;
        prequalificationId?: string | null;
        sourceId?: string | null;
        state?: string | null;
    };
    financedAmount: number | null;
    selectedPlan?: PartialDeep<{ planNumber?: string | null }> | null;
    source: LoanApplicationSubmitSource2;
    submittingUser?: SubmittingUser;
    isPrequalification: boolean;
}

function stripPhoneFormatting(phone: string | undefined | null): string | undefined {
    if (!phone) {
        return undefined;
    }
    return phone.replace(/[\(\)\s-]/g, '');
}

function extractLastFourSSN(ssn: string | undefined | null): string | undefined {
    if (!ssn) {
        return undefined;
    }
    const digitsOnly = ssn.replace(/\D/g, '');
    return digitsOnly.slice(-4) || undefined;
}

export function prepareExternalApplicationFromApplicantData({
    applicationData,
    setupData,
    financedAmount,
    selectedPlan,
    source,
    submittingUser,
    isPrequalification,
}: PrepareExternalApplicationFromApplicantDataParams): ExternalApplicationRequest {
    const primaryApplicant = applicationData.applicant?.primaryApplicant;
    const address = primaryApplicant?.jobDetails?.address;

    return {
        providerName: setupData.provider,
        tenantId: setupData.tenantId,
        buId: setupData.buId,
        amount: financedAmount,
        state: setupData.state,
        jobId: setupData.jobId,
        technicianId: setupData.technicianId,
        customerId: setupData.customerId,
        source,
        sourceId: setupData.sourceId,
        submittingUser,
        applicant: {
            firstName: primaryApplicant?.firstName,
            lastName: primaryApplicant?.lastName,
            email: primaryApplicant?.email,
            phone: stripPhoneFormatting(primaryApplicant?.primaryPhone),
            address: {
                street: address?.street,
                address2: address?.address2,
                city: address?.city,
                state: address?.state,
                zip: address?.zip,
            },
        },
        lastFourSSN: extractLastFourSSN(primaryApplicant?.ssn),
        planNumber: selectedPlan?.planNumber ?? undefined,
        isPrequalification,
        prequalId: setupData.prequalificationId ?? undefined,
        sendEmail: false,
        applicantDeliveryMethod: DeliveryMethod.None,
    };
}
